import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md flex items-center justify-center text-lg bg-primary-500 text-background-50">
                <i className="ri-eye-2-line" />
              </span>
              <span className="font-heading font-bold text-xl text-foreground-950">看料社</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              看料爆料专区，把公开可见的爆料版块、频道与栏目集中整理成清晰的入口，按板块就能快速翻到想看的内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 text-base mb-4">网站导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/channels" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">频道入口大全</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/contact" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 text-base mb-4">热门版块</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/channels" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">明星八卦版块</Link></li>
              <li><Link to="/channels" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">影视爆料频道</Link></li>
              <li><Link to="/channels" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">综艺热点栏目</Link></li>
              <li><Link to="/channels" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">全网热搜频道</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 text-base mb-4">联系与反馈</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0"><i className="ri-mail-line" /></span>
                <span>hi@kanliaoshe.example.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0"><i className="ri-time-line" /></span>
                <span>内容整理：每日 09:00 - 23:00</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0"><i className="ri-feedback-line" /></span>
                <span>线索提交建议在站内留言</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 看料社 · 本站内容整理自公开渠道，仅供资讯浏览。
          </p>
          <p className="text-xs text-foreground-500">
            本站为频道入口导航站点，不对未经证实的信息作结论性表述。
          </p>
        </div>
      </div>
    </footer>
  );
}